import React from 'react';
import { useTranslation } from 'react-i18next';
import { displayAvailableDays } from '../../utils';

interface AvailableWeekdaysProps extends React.HTMLAttributes<HTMLDivElement> {
    ticket: {
        enableActivateWeekdays?: string[];
        [key: string]: any;
    };
    labelClass?: string;
    dividerClass?: string;
    valueClass?: string;
}

const AvailableWeekdays: React.FC<AvailableWeekdaysProps> = ({
    ticket,
    labelClass,
    dividerClass,
    valueClass,
    ...rest
}) => {
    const { t } = useTranslation();
    const { enableActivateWeekdays } = ticket ?? {};

    if (!enableActivateWeekdays) {
        return <></>;
    }

    const showLabel = 0 < enableActivateWeekdays.length && enableActivateWeekdays.length < 8;

    return (
        <div {...rest}>
            {showLabel && (
                <>
                    <span className={labelClass}>{t('ticket-detail.available-days')}</span>
                    <span className={dividerClass}>{': '}</span>
                </>
            )}
            <span className={valueClass}>{displayAvailableDays(enableActivateWeekdays, t)}</span>
        </div>
    );
};

export default AvailableWeekdays;
